import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { FrameName } from "../config";
import { UpgradeIds } from "../config/upgrades";
import ShipyardBuildingTileEntity, {
	BIG_SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT,
} from "./ShipyardBuildingTileEntity";

class BigShipyardBuildingTileEntity extends ShipyardBuildingTileEntity {
	public static readonly frameName = FrameName.BIG_SHIPYARD;

	public get seaExplorationPower(): number {
		return (
			BIG_SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT +
			getUpgradeCurrentReplaceValueById(UpgradeIds.seafaring)
		);
	}

	public get fishingBoats(): number {
		return (
			BIG_SHIPYARD_AVAILABLE_FISHING_BOATS_COEFFICIENT +
			getUpgradeCurrentReplaceValueById(UpgradeIds.dry_dock)
		);
	}
}

export default BigShipyardBuildingTileEntity;
